<template>
  <div class="justify-content-center align-items-center w-100 d-flex" style="height: 100vh">
    <div class="col-12 col-sm-8 col-md-6 col-lg-4">
      <h5 class="text-center">Log In as an Admin</h5>
      <div class="text-center">
        <span class="text-danger" id="invalid" ref="invalid"></span>
      </div>
      <form>
        <div class="form-group">
          <input type="text" class="form-control bg-light rounded-0" name="username" placeholder="Username" v-model="username" ref="loginUsername">
          <span class="text-danger" style="font-size: 12px" ref="inputWarning1"></span>
        </div>
        <div class="form-group">
          <input type="password" class="form-control bg-light rounded-0" name="password" placeholder="Password" v-model="password" ref="loginPassword" v-on:keyup.enter="save">
          <span class="text-danger" style="font-size: 12px" ref="inputWarning2"></span>
        </div>

        <button type="button" style="font-weight: bold;" class="col-12 btn btn-primary rounded-0" v-on:click="save" v-if="!processing">Log In</button>
        <button type="button" style="font-weight: bold;" class="col-12 btn btn-warning rounded-0" disabled v-else>Processing...</button>
      </form>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import App from '@/App'

export default {
  data() {
    return {
      processing: false,
      username: '',
      password: '',
      token: null,
      url: App.data().url,
      rolecode: App.data().rolecode
    }
  },
  methods: {
    save() {
      this.processing = true;

      var loginUsername = this.$refs.loginUsername;
      var loginPassword = this.$refs.loginPassword;
      var inpWarning1 = this.$refs.inputWarning1;
      var inpWarning2 = this.$refs.inputWarning2;
      var invalid = this.$refs.invalid;

      if(this.username == "") {
        loginUsername.style.borderBottom = "3px solid red"
        inpWarning1.innerHTML = "field cannot be empty!"
      } else {
        loginUsername.style.borderBottom = "1px solid #ccc"
            inpWarning1.innerHTML = ""
      }

      if(this.password == "") {
        loginPassword.style.borderBottom = "3px solid red"
        inpWarning2.innerHTML = "field cannot be empty!"
      } else {
        loginPassword.style.borderBottom = "1px solid #ccc"
            inpWarning2.innerHTML = ""
      }

      if(this.username != "" && this.password != "") {
        const headers = {
          'Authorization': localStorage.getItem('token'),
          'Content-Type':'application/json',
          'Accept': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
          // 'withCredentials': true,
        }

        var dataUser = {
          username: this.username.toLowerCase(),
          email: this.username.toLowerCase(),
          password: this.password
        }

        axios.post(this.url.login, dataUser
          ).then(response => {
          if(response.status === 200){
            this.token = response.data.token;
            this.getUser(response.data.ID);
          }
        }).catch(e=>{
          alert('login failed')
          invalid.innerHTML = "Invalid Username or Password!"
          this.processing = false;
        });

        // Dev Only
        // localStorage.setItem('eclass-token', 'tes');
        // this.$root.$emit('isLoggedIn');
        // this.$router.push('/');
      }
      // this.processing = false;
    },
    getUser(id){
      axios.get(this.url.user + '/' + id).then(res => {
        var user = res.data.userData;

        this.checkRole(user);
      });
    },
    checkRole(user){
      var invalid = this.$refs.invalid;
      var role = user.role;

      // if(user.role === 1){
      if(role === this.rolecode.admin || role === this.rolecode.superadmin){
        alert('login success');
        this.$root.$emit('isLoggedIn');

        localStorage.setItem('eclass-token', this.token);
        localStorage.setItem('eclass-user', JSON.stringify(user));
      }else{
        alert('no authorization.');
        invalid.innerHTML = "No authorization."
      }

      this.processing = false;
    }
  }
}

</script>